module.exports = __webpack_public_path__ + "static/media/franklin.08225217.ttf";